export const appSettings = {
    productImageRatio: 1.5
};
